import { Box, useTheme } from "@mui/material";
import CloseSquerSVG from "../../../../../../../../media/images/icons/close-squer";

interface Props {
  index: number;
  handleDeleteDoc: (index: number) => void;
}

export default function RemoveDocButton(props: Props) {
  const { handleDeleteDoc, index } = props;
  const theme = useTheme();
  return (
    <Box
      onClick={() => handleDeleteDoc(index)}
      sx={{
        cursor: "pointer",
        position: "absolute",
        // border: "1px solid gray",
        top: 0,
        right: 0,
        width: "34px",
        height: "34px",
        // borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CloseSquerSVG size={40} color={theme.palette.error.main} />
    </Box>
  );
}
